import { Component, OnInit } from '@angular/core';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { ContractService } from './services/contract.service';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss']
})
export class ContractComponent implements OnInit {
  accessRoles: any;
  searchText: string = '';
  constructor(
    public sidePanelService:SidePanelService,
    public contractService:ContractService
  ) { 
    this.sidePanelService.initSideDrawer('contract');
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
  }

  ngOnInit(): void {
  }

  onSearchChange(searchValue: string) {
    this.contractService.headerSearchEventEmitter.emit(searchValue);
  }

}
